import React, { useState } from "react";
import { Button } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import { Link } from "react-router-dom";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";
//OAERDOGAN;447740;05032025
interface ByzNurseAddButtonProps extends React.ComponentProps<typeof Button> {
  onClick?: (
  ) => void;
  link?: string;
  popup?: boolean;
  disabledd?: boolean; 
}
const StyledButton = styled(Button)<{ popup?: boolean }>(({ popup, theme, disabled }) => ({
  width: "96px",
  height: "36px",
  borderRadius: "20px", 
  padding: "4px 10px",
  gap: "6px",
  fontFamily: "Poppins",
  fontWeight: 400,
  fontSize: "13px",
  lineHeight: "22px",
  letterSpacing: "0px",
  textTransform: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "row", 
  border: `1px solid ${disabled ? theme.palette.action.disabled : "#2979C3"}`,
  backgroundColor: disabled 
    ? alpha(theme.palette.action.disabled, 0.12)
    : "#63B4FF33",
  color: disabled ? theme.palette.action.disabled : "#2979C3",
  "&:hover": {
    backgroundColor: disabled ? alpha(theme.palette.action.disabled, 0.12) : "#2979C3",
    color: disabled ? theme.palette.action.disabled : "#fff",
  },
}));

const ByzNurseAddButton: React.FC<ByzNurseAddButtonProps> = ({ onClick, link, popup , disabledd, disabled, ...rest }) => {
  const { t } = useTranslate();
  const [hover, setHover] = useState(false);
  const isDisabled = disabledd || disabled;

  const buttonContent = (
    <>
      <img
        src={hover && !isDisabled ? "/assets/icons/add/add.svg" : "/assets/icons/add/add2.svg"}
        alt="Ekle"
        style={{
          width: "16px",
          height: "16px",
          marginRight: "5px", 
          transition: "0.2s ease-in-out",
          filter: isDisabled ? "grayscale(100%) opacity(0.5)" : "none",
        }}
      />
      <ByzMuiTypography
        fontWeight={400}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginLeft: "5px", 
        }}
      >
        {t("buttons.add")}
        
      </ByzMuiTypography>
    </>
  );

  return link ? (
    <Link to={link} style={{ textDecoration: "none" }}>
      <StyledButton
        popup={popup}
        disabled={isDisabled}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        {...rest}
      >
        {buttonContent}
      </StyledButton>
    </Link>
  ) : (
    <StyledButton
      popup={popup}
      onClick={onClick}
      disabled={isDisabled}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      {...rest}
    >
      {buttonContent}
    </StyledButton>
  );
};

export default ByzNurseAddButton;
